import useAmplitude from './useAmplitude'

export default () => {
  const amplitude = useAmplitude()
  if (!amplitude) return null

  return amplitude.getInstance()
}
